import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { MainLayout } from '@/components/layouts/main-layout';
import { AppProviders } from '@/components/providers';
import { WalletConnectorModal } from '@/components/wallet/connector-modal';
import {
  CrossChainRoute,
  crossChainRoutesQueryOptions,
} from '@/lib/query-options';
import { getTheme, setTheme } from '@/lib/utils/theme';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  crossChainRoutes: CrossChainRoute[];
  theme: string;
}>()({
  component: RootDocument,
  async beforeLoad({ context: { queryClient } }) {
    await queryClient.prefetchQuery(crossChainRoutesQueryOptions);
    return {
      theme: getTheme(),
      crossChainRoutes: await queryClient.ensureQueryData(
        crossChainRoutesQueryOptions,
      ),
    };
  },
});

function RootDocument() {
  useEffect(() => {
    setTheme('light');
  }, []);

  return (
    <AppProviders>
      {/* Content */}
      <MainLayout>
        <RootContent />
      </MainLayout>

      <WalletConnectorModal />

      {/* Devtools */}
      <ReactQueryDevtools />
      <TanStackRouterDevtools />
    </AppProviders>
  );
}

function RootContent() {
  return <Outlet />;
}
